export const VALIDATE_MESSAGES = {
  REQUIRED: "errors.required",
};

export const getMaxLengthErrorMsg=(max:number)=>{
  return 
}